// import "react-perfect-scrollbar/dist/css/styles.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-quill/dist/quill.snow.css";
import "nprogress/nprogress.css";
import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import LocalizationProvider from "@material-ui/lab/LocalizationProvider";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import StyledEngineProvider from "@material-ui/core/StyledEngineProvider";
import App from "./App";
import { AuthProvider } from "./contexts/JWTContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import * as serviceWorker from "./serviceWorker";
import store from "./store";
import "./index.css";
import { SnackbarProvider } from "notistack";
import $ from "jquery";
import jQuery from "jquery";
import Cookies from "js-cookie";

ReactDOM.render(
  <StrictMode>
    <SnackbarProvider
      dense
      maxSnack={3}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <ReduxProvider store={store}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LocalizationProvider>
      </ReduxProvider>
    </SnackbarProvider>
  </StrictMode>,
  document.getElementById("root")
);

// jQuery(function ($) {
//   let currentWebsite = window.location.hostname;
//   let allCookies = Cookies.get();
//   let referrerDomain = "";

//   const googleURLs = ["google.com", "search.google.com", "www.google.com"];
//   const facebookURLs = [
//     "facebook.com",
//     "l.facebook.com",
//     "m.facebook.com",
//     "lm.facebook.com",
//     "www.facebook.com",
//   ];
//   const bingURLs = ["bing.com", "www.bing.com"];
//   const youtubeURLs = ["youtube.com", "m.youtube.com", "www.youtube.com"];
//   const linkedinURLs = ["linkedin.com", "www.linkedin.com"];
//   const twitterURLs = ["twitter.com", "mobile.twitter.com", "www.twitter.com"];

//   // const visitedCookie = Cookies.get('visited') !== undefined ? JSON.parse(Cookies.get('visited')) : undefined;
//   const referrer = document.referrer;

//   if (referrer !== "") {
//     referrerDomain = new URL(referrer).hostname;
//   }

//   const getAllParameters = (url = window.location.href) => {
//     const urlObject = new URL(url);
//     const params = new URLSearchParams(urlObject.search);
//     let paramsObject = {};
//     for (let pair of params.entries()) {
//       if (
//         pair[0].toLowerCase() !== "s" &&
//         pair[0].toLowerCase() !== "post_type" &&
//         pair[0].toLowerCase() !== "complianz_scan_token" &&
//         pair[0].toLowerCase() !== "complianz_id"
//       ) {
//         paramsObject[pair[0].toLowerCase()] = pair[1];
//       }
//     }

//     return paramsObject;
//   };

//   const saveParametersToCookie = (parameters) => {
//     for (let key in parameters) {
//       Cookies.set("ref_" + key, parameters[key], {
//         expires: 7,
//         path: "/",
//         domain: ".bkvenergy.com",
//       });
//     }
//   };

//   const deleteRefCookies = () => {
//     for (let key in allCookies) {
//       if (key.startsWith("ref_")) {
//         Cookies.remove(key, { path: "/", domain: ".bkvenergy.com" });
//       }
//     }
//   };

//   let params = getAllParameters();
//   let urlPromoCode = params["promo"] || null;
//   let traffic_type = "Direct";

//   const currentPath = window.location.pathname;
//   const isBlogOrLearningOrNewsroom =
//     currentPath.includes("/blog") ||
//     currentPath.includes("/learning-center") ||
//     currentPath.includes("/learning-center-topic") ||
//     currentPath.includes("/newsroom") ||
//     currentPath.includes("/press-releases") ||
//     currentPath.includes("/media-assets") ||
//     currentPath.includes("/photos-category");
//   const isDirectTraffic = referrer === "";
//   const urlParamsToCheck = [
//     "utm_source",
//     "utm_medium",
//     "utm_campaign",
//     "utm_term",
//     "fbclid",
//     "gclid",
//     "msclkid",
//     "li_fat_id",
//     "twclid",
//   ];

//   if (
//     facebookURLs.includes(referrerDomain) &&
//     urlParamsToCheck.some((param) => params[param])
//   ) {
//     traffic_type = "Paid Social";
//     if (!params["promo"]) {
//       params["promo"] = "PMEMET0001";
//     }
//   } else if (
//     googleURLs.includes(referrerDomain) &&
//     urlParamsToCheck.some((param) => params[param])
//   ) {
//     traffic_type = "Paid Search";
//     if (!params["promo"]) {
//       params["promo"] = "PMEGSE0001";
//     }
//   } else if (
//     bingURLs.includes(referrerDomain) &&
//     urlParamsToCheck.some((param) => params[param])
//   ) {
//     traffic_type = "Paid Social";
//     if (!params["promo"]) {
//       params["promo"] = "PMEBIN0001";
//     }
//   } else if (
//     youtubeURLs.includes(referrerDomain) &&
//     urlParamsToCheck.some((param) => params[param])
//   ) {
//     traffic_type = "Paid Social";
//     if (!params["promo"]) {
//       params["promo"] = "PMEYOU0001";
//     }
//   } else if (
//     linkedinURLs.includes(referrerDomain) &&
//     urlParamsToCheck.some((param) => params[param])
//   ) {
//     traffic_type = "Paid Social";
//     if (!params["promo"]) {
//       params["promo"] = "PMELIN0001";
//     }
//   } else if (
//     twitterURLs.includes(referrerDomain) &&
//     urlParamsToCheck.some((param) => params[param])
//   ) {
//     traffic_type = "Paid Social";
//     if (!params["promo"]) {
//       params["promo"] = "PMETWI0001";
//     }
//   } else if (
//     facebookURLs.includes(referrerDomain) &&
//     isBlogOrLearningOrNewsroom
//   ) {
//     traffic_type = "Organic Social";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSOC0001";
//     }
//   } else if (
//     googleURLs.includes(referrerDomain) &&
//     isBlogOrLearningOrNewsroom
//   ) {
//     traffic_type = "Organic Search";
//     if (!params["promo"]) {
//       params["promo"] = "SEOVIC0001";
//     }
//   } else if (bingURLs.includes(referrerDomain) && isBlogOrLearningOrNewsroom) {
//     traffic_type = "Organic Social";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSOC0001";
//     }
//   } else if (
//     youtubeURLs.includes(referrerDomain) &&
//     isBlogOrLearningOrNewsroom
//   ) {
//     traffic_type = "Organic Social";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSOC0001";
//     }
//   } else if (
//     linkedinURLs.includes(referrerDomain) &&
//     isBlogOrLearningOrNewsroom
//   ) {
//     traffic_type = "Organic Social";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSOC0001";
//     }
//   } else if (
//     twitterURLs.includes(referrerDomain) &&
//     isBlogOrLearningOrNewsroom
//   ) {
//     traffic_type = "Organic Social";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSOC0001";
//     }
//   } else if (facebookURLs.includes(referrerDomain)) {
//     traffic_type = "Organic Social";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSOC0001";
//     }
//   } else if (googleURLs.includes(referrerDomain)) {
//     traffic_type = "Organic Search";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSEO00001";
//     }
//   } else if (bingURLs.includes(referrerDomain)) {
//     traffic_type = "Organic Social";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSOC0001";
//     }
//   } else if (youtubeURLs.includes(referrerDomain)) {
//     traffic_type = "Organic Social";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSOC0001";
//     }
//   } else if (linkedinURLs.includes(referrerDomain)) {
//     traffic_type = "Organic Social";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSOC0001";
//     }
//   } else if (twitterURLs.includes(referrerDomain)) {
//     traffic_type = "Organic Social";
//     if (!params["promo"]) {
//       params["promo"] = "ORGSOC0001";
//     }
//   } else if (isDirectTraffic) {
//     traffic_type = "Direct";
//     if (!params["promo"]) {
//       params["promo"] = "SEOEIQ0001";
//     }
//   } else {
//     traffic_type = "Referral";
//     if (Object.keys(params).length > 0) {
//       if (!params["promo"]) {
//         params["promo"] = "SEOEIQ0001";
//       }
//     } else if (!allCookies["ref_promo"]) {
//       params["promo"] = "SEOEIQ0001";
//     }
//   }

//   function processLinksAndForms() {
//     allCookies = Cookies.get(); // Refresh the cookies

//     if (
//       currentWebsite === "enroll.bkvenergy.com" ||
//       currentWebsite === "signup.bkvenergy.com"
//     ) {
//       $("a[href*='bkvenergy.com']").each(function () {
//         //bkvenergydev.wpengine.com
//         let link = $(this);
//         let href = link.attr("href");
//         if (href) {
//           for (let key in allCookies) {
//             if (key.startsWith("ref_")) {
//               let actualKey = key.slice(4);
//               let separator = href.indexOf("?") !== -1 ? "&" : "?";
//               href = href + separator + actualKey + "=" + allCookies[key];
//               link.attr("href", href);
//             }
//           }
//         }
//       });
//     } else {
//       $(
//         "a#enroll-cta__header, a#enroll-cta__404, a#find-your-power-flip-the-switch"
//       ).each(function () {
//         let link = $(this);
//         let href = link.attr("href");
//         if (href) {
//           for (let key in allCookies) {
//             if (key.startsWith("ref_")) {
//               let actualKey = key.slice(4);
//               let separator = href.indexOf("?") !== -1 ? "&" : "?";
//               href = href + separator + actualKey + "=" + allCookies[key];
//               link.attr("href", href);
//             }
//           }
//         }
//       });

//       $('form[name="find-your-power"]').each(function () {
//         let form = $(this);

//         for (let key in allCookies) {
//           if (key.startsWith("ref_")) {
//             let actualKey = key.slice(4);

//             if (!form.find('input[name="' + actualKey + '"]').length) {
//               $(
//                 '<input type="hidden" name="' +
//                   actualKey +
//                   '" value="' +
//                   allCookies[key] +
//                   '">'
//               ).insertBefore(form.find('input[type="submit"]'));
//             } else {
//               form.find('input[name="' + actualKey + '"]').val(allCookies[key]);
//             }
//           }
//         }
//       });
//     }
//   }

//   let existingPromoCode = Cookies.get("ref_promo");
//   if (!existingPromoCode || urlPromoCode) {
//     deleteRefCookies();
//     saveParametersToCookie(params);

//     if (
//       currentWebsite === "enroll.bkvenergy.com" ||
//       currentWebsite === "signup.bkvenergy.com"
//     ) {
//       // Cookies.set('visited', JSON.stringify({visited: true, hostname: referrerDomain, parameters: params}), { expires: 7, domain: '.bkvenergy.com' });
//       processLinksAndForms();
//     } else {
//       $.ajax({
//         url: "/wp-admin/admin-ajax.php",
//         type: "post",
//         beforeSend: function () {
//           allCookies = Cookies.get(); // Update allCookies right before the AJAX request
//         },
//         data: {
//           action: "save_url_traffic_data",
//           hostname: referrerDomain,
//           parameters: JSON.stringify(allCookies),
//           traffic_type: traffic_type,
//         },
//         success: function (response) {
//           console.log("success");
//           console.log(response);
//           // Cookies.set('visited', JSON.stringify({visited: true, hostname: referrerDomain, parameters: params}), { expires: 7, domain: '.bkvenergy.com' });
//           processLinksAndForms();
//         },
//         error: function (response) {
//           console.log("error");
//           console.log(response);
//         },
//       });
//     }
//   } else {
//     processLinksAndForms();
//   }
// });

// If you want to enable client cache, register instead.
// serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
